import { imgUrl } from '~src/commonInfra/utils/ImgUrl';

import { cssClass } from '../../style';

export namespace SharedWithMeSpaceStyle {
  export const sharedWithMeSpaceCssPrefix = 'SharedWithMeSpace';

  export const getAccessDeniedIcon = () => cssClass(sharedWithMeSpaceCssPrefix, 'access-denied-icon', {
    display: 'inline-block',
    backgroundImage: imgUrl('access_denied.svg'),
    backgroundPosition: 'left center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '16px 16px',
    height: '16px',
    marginLeft: '6px',
    width: '16px',
  });
}